import { render } from "./ImagesView.vue?vue&type=template&id=5bd1bebc&scoped=true"
import script from "./ImagesView.vue?vue&type=script&lang=js"
export * from "./ImagesView.vue?vue&type=script&lang=js"

import "./ImagesView.vue?vue&type=style&index=0&id=5bd1bebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd1bebc"]])

export default __exports__